import BusinessSetup from './BusinessSetup';

export default BusinessSetup;
